// extracted by mini-css-extract-plugin
export default {"header":"navbar_header__cmagb","active":"navbar_active__ZFKvS"};